import React from 'react';
import { ButtonControl } from 'spark-core-dx/components';
import { useCoreContext, useAuthContext, useCoreStateContext } from 'spark-core-dx/contexts';
import { useCoreRoute } from 'spark-core-dx/hooks';
import '../screens/home.scss';

const LogoWordmark = () => (
  <svg
    className="logo-wordmark"
    xmlns="http://www.w3.org/2000/svg"
    width="560"
    height="120"
    viewBox="0 0 3520 720"
    role="img"
    aria-label="CONVOKE DX"
  >
    <g opacity="1">
      <text x="1760" y="480" fontSize="440" letterSpacing="4" textAnchor="middle">
        <tspan fill="#00356B">CONVOKE</tspan>
        <tspan fill="#4FC3F7">DX</tspan>
      </text>
    </g>
  </svg>
);

const PublicSiteHeader = () => {
  const coreContext = useCoreContext();
  const coreState = useCoreStateContext();
  const { isAuthorized } = useAuthContext();
  const { coreNavigate } = useCoreRoute();
  const rootCoreState = coreState?.global ?? coreState;
  const globalNotLoading = rootCoreState?.get?.('globalNotLoading') ?? {};
  const forceGlobalLoading = rootCoreState?.get?.('forceGlobalLoading')?.forceGlobalLoading;
  const authCallBack = sessionStorage.getItem('AuthCallBack');
  const isStartupReady = Boolean(coreContext?.Launch)
    && coreContext?.applicationStatus === 2
    && Boolean(coreContext?.RoutingConfig)
    && globalNotLoading?.sparkAppStyle === true
    && globalNotLoading?.sparkIndexStyle === true
    && globalNotLoading?.userProfileConfig === true
    && !authCallBack
    && !forceGlobalLoading;
  const loginDisabledTitle = coreContext?.applicationStatus === 0
    ? 'Services are unavailable right now.'
    : 'Loading startup operations...';

  const navigatePublicSection = (e, target) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    window.location.assign(`/${target}`);
  };

  const goLogin = () => {
    if (!isStartupReady) {
      return;
    }

    coreNavigate(isAuthorized ? coreContext.RedirectScreenKey : '/login/');
  };

  return (
    <header className="site-header">
      <a className="brand" href="/#landing" onClick={(e) => navigatePublicSection(e, '#landing')}>
        <LogoWordmark />
      </a>

      <nav className="main-nav">
        <a href="/#about" onClick={(e) => navigatePublicSection(e, '#about')}>Product</a>
        <a href="/marketplace">Marketplace</a>
        <a href="/#consulting" onClick={(e) => navigatePublicSection(e, '#consulting')}>Consulting</a>
        <a href="/#partners" onClick={(e) => navigatePublicSection(e, '#partners')}>Customers &amp; Partners</a>
        <a href="/#contact" onClick={(e) => navigatePublicSection(e, '#contact')}>More Info</a>
      </nav>

      <ButtonControl
        className="header-login"
        disabled={!isStartupReady}
        disabledTitle={loginDisabledTitle}
        onClick={goLogin}
      >
        Login
      </ButtonControl>
    </header>
  );
};

export default PublicSiteHeader;
